import { render, staticRenderFns } from "./GiveawayStats.vue?vue&type=template&id=566c001a"
import script from "./GiveawayStats.vue?vue&type=script&lang=js"
export * from "./GiveawayStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports